/* Crioh Accessories — cascada de borrado en el carrito (tema Horizon)
 *
 * Si se quita el producto PADRE, sus accesorios quedan "huérfanos": su
 * _crioh_acc_link_id ya no tiene una línea con _crioh_acc_role == 'main'. Como
 * son accesorios "de" ese producto, los eliminamos (comportamiento pack-atómico).
 *
 * Se engancha al evento nativo del tema 'cart:update' (ThemeEvents.cartUpdate),
 * que se dispara en cada cambio del carrito. Tras borrar, dispara otro
 * 'cart:update' con el recuento real para que Horizon re-renderice la sección
 * (Section Rendering API) y el contador del header. Es idempotente: tras borrar,
 * /cart.js ya no trae huérfanos, así que no vuelve a actuar.
 */
(function () {
  'use strict';

  var SELF_SOURCE = 'crioh-accessory-cascade';
  var running = false;

  function findOrphanKeys(cart) {
    var byLink = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      var link = p._crioh_acc_link_id;
      if (!link) return;
      if (!byLink[link]) byLink[link] = { hasMain: false, accessoryKeys: [] };
      if (p._crioh_acc_role === 'main') byLink[link].hasMain = true;
      else if (p._crioh_acc_role === 'accessory') byLink[link].accessoryKeys.push(it.key);
    });
    var orphanKeys = [];
    Object.keys(byLink).forEach(function (link) {
      if (!byLink[link].hasMain) orphanKeys = orphanKeys.concat(byLink[link].accessoryKeys);
    });
    return orphanKeys;
  }

  async function checkCascade() {
    if (running) return;
    running = true;
    try {
      var cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) return;
      var cart = await cartRes.json();

      var orphanKeys = findOrphanKeys(cart);
      if (!orphanKeys.length) return;

      var updates = {};
      orphanKeys.forEach(function (k) { updates[k] = 0; });
      var upRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      if (!upRes.ok) return;

      var newCart = await upRes.json();
      var count = (newCart && typeof newCart.item_count === 'number') ? newCart.item_count : null;

      // Persistencia que usa el cart-icon de Horizon.
      if (count !== null) {
        try {
          sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
        } catch (e) {}
      }

      // Re-render nativo: el tema re-renderiza la sección al recibir cart:update
      // sin HTML de secciones (Section Rendering). itemCount = total absoluto.
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: SELF_SOURCE, itemCount: count == null ? 0 : count } },
      }));
    } catch (err) {
      console.error('[crioh-accessory-cart] cascade error:', err);
    } finally {
      running = false;
    }
  }

  document.addEventListener('cart:update', function (e) {
    // No reaccionar a nuestro propio evento (corta cualquier bucle).
    var src = e && e.detail && e.detail.data && e.detail.data.source;
    if (src === SELF_SOURCE) return;
    checkCascade();
  });
})();
